import { render, staticRenderFns } from "./diagnose-history-simple-table-expand.vue?vue&type=template&id=bd9d40a2&scoped=true&"
import script from "./diagnose-history-simple-table-expand.vue?vue&type=script&lang=js&"
export * from "./diagnose-history-simple-table-expand.vue?vue&type=script&lang=js&"
import style0 from "./diagnose-history-simple-table-expand.vue?vue&type=style&index=0&id=bd9d40a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9d40a2",
  null
  
)

component.options.__file = "diagnose-history-simple-table-expand.vue"
export default component.exports